
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as usp0sDHsBcTGemWIbe6h9t9S2lLRHk7aHaVvFHwuH1IC4AMeta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/usp.vue?macro=true";
import { default as aboutljPcSirssgYMqdMWZE4MtJQmZppgpBwr8w5Gjl2aahoMeta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/about.vue?macro=true";
import { default as indexxZigTQR6mH5U3wA2nX10im_nidgJorsAiNFPzdsqAu0Meta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/index.vue?macro=true";
import { default as rapidks4lG678lODC0fiVe0q98xH_45rK2ZvMOwa5_fM5AMAIMMeta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/rapid.vue?macro=true";
import { default as contactKo8ojOHhVU4qwFawhxzJf5w1o_Lr4mbpfFG_rUn8kS0Meta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/contact.vue?macro=true";
import { default as processnwIk_aiJEvx1v_45g1VZZCbKJIKw2zUUW5NuVALhz0CJ8Meta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/process.vue?macro=true";
import { default as feedbackHKyfvPfbZ9ZTJK1FUd4ZpHp7NEQRqPDDgtd1Mxc9Ks0Meta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/feedback.vue?macro=true";
import { default as automationsIcMf6EuG0x_45zOxZR1_vK_v53mcbJgA3n4yZKJVIN5ioMeta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automations.vue?macro=true";
import { default as indexGQ0YbyT2hkxJs4fibIc3TTNPsYUmVQxXybFJ5CNBm6MMeta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/tools/index.vue?macro=true";
import { default as llanasL44Qvw71UNOkBWyk8Gsm44NNr0XJSu_45qOcSIsvxcDYMeta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/tools/llana.vue?macro=true";
import { default as cto_45serviceshLhAYfN3lRg7kunxVfAxnyHuAraSHwT05cPNOiyVcigMeta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/cto-services.vue?macro=true";
import { default as indexTtWr1D6EeBXrLHfklcHphB26bE6ZBqacnBdphdUWeVkMeta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automation/index.vue?macro=true";
import { default as automation2VB4Kui5HlsCMUQJetEo6_45S6100TIOMMnlTJ8OMisVEMeta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/forms/automation.vue?macro=true";
import { default as new_45clientBTNCEVvAwvltnAAORZ9ZcY6pKeF8VdfpT7UTY8P4tzQMeta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/forms/new-client.vue?macro=true";
import { default as _91_46_46_46slug_93JQM_451UC7cZ2cXfqAEv88Gm9BZb_45gmSYngmFMPJJKSpUMeta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automation/[...slug].vue?macro=true";
import { default as new_45automationuqKsjAY33Jj34TBxvXh5fGmnCznujkAu_YxDDZwGHswMeta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/forms/new-automation.vue?macro=true";
import { default as _91_46_46_46slug_93f2eOYwuNadoQhE60r3wcdLLqAyMxVFHpPN89ShNNB00Meta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automation/tool/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93f3jJPKh4sMADDiOHrhUQR73O7m1BevDiq11imTiI6cgMeta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automation/category/[...slug].vue?macro=true";
import { default as what_45is_45ecommerce_45automation15MuHH6eZ3zDdA1z41dpePN515cnDE2f_1xnAwaM8TsMeta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automation/faq/ecommerce/what-is-ecommerce-automation.vue?macro=true";
import { default as how_45to_45use_45marketing_45automation_45for_45ecommercewdhQ95MN_45iDAcc__45_45IjwXEamsDXbw2C_45py475yXNTXMMeta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automation/faq/ecommerce/how-to-use-marketing-automation-for-ecommerce.vue?macro=true";
import { default as how_45to_45conduct_45automation_45testing_45on_45the_45ecommerceq0w5mrHDxKuPo_qfWPeslkKO_45LYYyo0ZmD_45sSYQVV0QMeta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automation/faq/ecommerce/how-to-conduct-automation-testing-on-the-ecommerce.vue?macro=true";
import { default as what_45is_45automated_45bookkeeping_45and_45how_45does_45it_45workj1BsdpRKyVA1wf59uZj7OvtCQ9cHrl5_ynTJgWvlwYEMeta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automation/faq/bookkeeping/what-is-automated-bookkeeping-and-how-does-it-work.vue?macro=true";
import { default as why_45you_45need_45automation_45testing_45services_45for_45your_45ecommerce_45business8g27r2To01UAlgVftGspPStf9ufkQbDE7Q5vy01JEUUMeta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automation/faq/ecommerce/why-you-need-automation-testing-services-for-your-ecommerce-business.vue?macro=true";
import { default as how_45bookkeeping_45process_45automation_45revolutionizes_45business_45operationstNarDvv6l__sbX8H0DeyPsS3UCKRlbWGyyfZAKdduCUMeta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automation/faq/bookkeeping/how-bookkeeping-process-automation-revolutionizes-business-operations.vue?macro=true";
import { default as how_45bookkeeping_45automation_45with_45ai_45is_45transforming_45financial_45managementGyIGO99VYSP3G_456sChWW0wQbxgIHKFtKqe6KKS3VXJUMeta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automation/faq/bookkeeping/how-bookkeeping-automation-with-ai-is-transforming-financial-management.vue?macro=true";
import { default as unlock_45the_45power_45of_45xero_45bookkeeping_45automation_45for_45your_45business_45successq6260MrC_45C4pVQKkpuuS1l5a11M6FkE4MoXFvb6201YMeta } from "/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automation/faq/bookkeeping/unlock-the-power-of-xero-bookkeeping-automation-for-your-business-success.vue?macro=true";
export default [
  {
    name: "usp",
    path: "/usp",
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/usp.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/index.vue")
  },
  {
    name: "rapid",
    path: "/rapid",
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/rapid.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/contact.vue")
  },
  {
    name: "process",
    path: "/process",
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/process.vue")
  },
  {
    name: "feedback",
    path: "/feedback",
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/feedback.vue")
  },
  {
    name: "automations",
    path: "/automations",
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automations.vue")
  },
  {
    name: "tools",
    path: "/tools",
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/tools/index.vue")
  },
  {
    name: "tools-llana",
    path: "/tools/llana",
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/tools/llana.vue")
  },
  {
    name: "cto-services",
    path: "/cto-services",
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/cto-services.vue")
  },
  {
    name: "automation",
    path: "/automation",
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automation/index.vue")
  },
  {
    name: "forms-automation",
    path: "/forms/automation",
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/forms/automation.vue")
  },
  {
    name: "forms-new-client",
    path: "/forms/new-client",
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/forms/new-client.vue")
  },
  {
    name: "automation-slug",
    path: "/automation/:slug(.*)*",
    meta: _91_46_46_46slug_93JQM_451UC7cZ2cXfqAEv88Gm9BZb_45gmSYngmFMPJJKSpUMeta || {},
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automation/[...slug].vue")
  },
  {
    name: "forms-new-automation",
    path: "/forms/new-automation",
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/forms/new-automation.vue")
  },
  {
    name: "automation-tool-slug",
    path: "/automation/tool/:slug(.*)*",
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automation/tool/[...slug].vue")
  },
  {
    name: "automation-category-slug",
    path: "/automation/category/:slug(.*)*",
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automation/category/[...slug].vue")
  },
  {
    name: "automation-faq-ecommerce-what-is-ecommerce-automation",
    path: "/automation/faq/ecommerce/what-is-ecommerce-automation",
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automation/faq/ecommerce/what-is-ecommerce-automation.vue")
  },
  {
    name: "automation-faq-ecommerce-how-to-use-marketing-automation-for-ecommerce",
    path: "/automation/faq/ecommerce/how-to-use-marketing-automation-for-ecommerce",
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automation/faq/ecommerce/how-to-use-marketing-automation-for-ecommerce.vue")
  },
  {
    name: "automation-faq-ecommerce-how-to-conduct-automation-testing-on-the-ecommerce",
    path: "/automation/faq/ecommerce/how-to-conduct-automation-testing-on-the-ecommerce",
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automation/faq/ecommerce/how-to-conduct-automation-testing-on-the-ecommerce.vue")
  },
  {
    name: "automation-faq-bookkeeping-what-is-automated-bookkeeping-and-how-does-it-work",
    path: "/automation/faq/bookkeeping/what-is-automated-bookkeeping-and-how-does-it-work",
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automation/faq/bookkeeping/what-is-automated-bookkeeping-and-how-does-it-work.vue")
  },
  {
    name: "automation-faq-ecommerce-why-you-need-automation-testing-services-for-your-ecommerce-business",
    path: "/automation/faq/ecommerce/why-you-need-automation-testing-services-for-your-ecommerce-business",
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automation/faq/ecommerce/why-you-need-automation-testing-services-for-your-ecommerce-business.vue")
  },
  {
    name: "automation-faq-bookkeeping-how-bookkeeping-process-automation-revolutionizes-business-operations",
    path: "/automation/faq/bookkeeping/how-bookkeeping-process-automation-revolutionizes-business-operations",
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automation/faq/bookkeeping/how-bookkeeping-process-automation-revolutionizes-business-operations.vue")
  },
  {
    name: "automation-faq-bookkeeping-how-bookkeeping-automation-with-ai-is-transforming-financial-management",
    path: "/automation/faq/bookkeeping/how-bookkeeping-automation-with-ai-is-transforming-financial-management",
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automation/faq/bookkeeping/how-bookkeeping-automation-with-ai-is-transforming-financial-management.vue")
  },
  {
    name: "automation-faq-bookkeeping-unlock-the-power-of-xero-bookkeeping-automation-for-your-business-success",
    path: "/automation/faq/bookkeeping/unlock-the-power-of-xero-bookkeeping-automation-for-your-business-success",
    component: () => import("/codebuild/output/src1606756812/src/client-juicyllama/www/pages/automation/faq/bookkeeping/unlock-the-power-of-xero-bookkeeping-automation-for-your-business-success.vue")
  }
]